import React from 'react';
import { FAMLY_INQUIRY_URL } from '../../../data/famly';
import { trackEvent } from '../../../firebase/analytics';

interface FamlyEnquiryLinkProps {
  /** Where on the site this CTA lives, e.g. 'nav_desktop', 'fees'. Used for analytics. */
  ctaLocation: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Opens the Famly enquiry form in a new tab and reports the click.
 * Famly sends `x-frame-options: SAMEORIGIN`, so the form can't be embedded —
 * an outbound link is the only option.
 */
export const FamlyEnquiryLink: React.FC<FamlyEnquiryLinkProps> = ({
  ctaLocation,
  className,
  children,
}) => (
  <a
    href={FAMLY_INQUIRY_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => {
      trackEvent({
        name: 'generate_lead',
        action: 'click',
        label: 'famly_enquiry',
        page: typeof window !== 'undefined' ? window.location.pathname : undefined,
        params: {
          destination: FAMLY_INQUIRY_URL,
          cta_location: ctaLocation,
        },
      });
    }}
    data-analytics={`famly-enquiry-${ctaLocation}`}
    className={className}
  >
    {children}
  </a>
);
